import React, { useState } from 'react';
import Menu from '@mui/material/Menu';
import { MenuList } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';
import Badge from '@mui/material/Badge';
import Divider from '@mui/material/Divider';
import ArgonTypography from 'components/ArgonTypography';
import ArgonBox from 'components/ArgonBox';
import NotificationItem from 'examples/Items/NotificationItem';
import { useNotifications } from 'context/NotificationContext';

function DynamicNotificationsMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  const { notifications, unreadCount, clearNotifications, markNotificationsAsRead } = useNotifications();

  const openMenu = (event) => {
    markNotificationsAsRead();
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => setAnchorEl(null);

  const handleClearAll = () => {
    clearNotifications();
    closeMenu();
  };

  const renderMenu = () => (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      open={Boolean(anchorEl)}
      onClose={closeMenu}
      sx={{ mt: 4 }}
    >
      <ArgonBox p={1} display="flex" justifyContent="space-between" alignItems="center">
        <ArgonTypography variant="caption1" color="textSecondary">
          Notifications
        </ArgonTypography>
        {notifications.length > 0 && (
          <ArgonTypography
            variant="caption"
            color="info"
            sx={{ cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
            onClick={handleClearAll}
          >
            Clear All
          </ArgonTypography>
        )}
      </ArgonBox>
      <Divider sx={{ margin: 0 }} />

      <MenuList
        sx={{
          maxHeight: '400px',
          overflowY: 'auto',
          paddingTop: 0,
          paddingBottom: 0,
          '&::-webkit-scrollbar': {
            width: '6px',
          },
          '&::-webkit-scrollbar-track': {
            borderRadius: '3px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#ccc',
            borderRadius: '3px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: '#aaa',
          },
        }}
      >
        {notifications.length > 0 ? (
          notifications.map((notification) => (
            <NotificationItem
              key={notification.id}
              image={notification.image}
              title={notification.title}
              date={notification.date}
              onClick={closeMenu}
            />
          ))
        ) : (
          <ArgonBox p={2}>
            <ArgonTypography variant="body2" color="textSecondary" align="center">
              No new notifications
            </ArgonTypography>
          </ArgonBox>
        )}
      </MenuList>
    </Menu>
  );

  return (
    <>
      <IconButton
        size="small"
        color="inherit"
        sx={{}}
        aria-controls="notification-menu"
        aria-haspopup="true"
        variant="contained"
        onClick={openMenu}
      >
        <Badge badgeContent={unreadCount} color="error" overlap="circular">
          <Icon>notifications</Icon>
        </Badge>
      </IconButton>
      {renderMenu()}
    </>
  );
}

export default DynamicNotificationsMenu;
